import React from "react";
// import ReactDOM from "react-dom";
import "antd/dist/antd.css";
// import "./index.css";
import { List } from "antd";
import { QualificationsCard } from "../Cards/QualificationsCard";
// import { ProjectCard } from "./../Cards/ProjectCard";
import { Heading } from "./../CategoryHeading/Heading";
import styles from "./Qualifications.module.css";

const data = [
  // {
  //     logo: "/Images/mern4.png",
  //     title: "Full-Stack Web Developer",
  //     organization: "Masai School",
  //     duration: "January 2021 - August 2021 | Remote",
  //     navigate_to: "github.com/SumanChakraborty1998",
  // },
  {
    logo: "/Images/bwu.svg",
    title: "B. Tech in Computer Science and Engineering",
    organization: "Brainware University",
    duration: "August 2017 - August 2021 | Kolkata",
    navigate_to:
      "https://drive.google.com/drive/folders/1VfShao8mkC4sJN9OQxaNGJS6XhHJ7TNb?usp=sharing",
    secured: "90%",
  },
  {
    logo: "/Images/wbchse.png",
    title: "Higher Secondary Examination",
    organization: "Dhamtore B. B. Vidyabhaban",
    duration: "February 2015 - 2016 | West Bengal",
    navigate_to:
      "drive.google.com/file/d/1z2ko3Do7TA2i35gK-C9S1seaQpEBeABk/view?usp=sharing",
    secured: "79.8%",
  },
  {
    logo: "/Images/wbbse.png",
    title: "Secondary Examination",
    organization: "Jotdwaria Vivekananda Vidyabhaban",
    duration: "January 2013 - 2014 | West Bengal",
    navigate_to:
      "drive.google.com/file/d/1z2ko3Do7TA2i35gK-C9S1seaQpEBeABk/view?usp=sharing",
    secured: "85.28%",
  },
];

export const Qualifications = () => {
  return (
    <div className={styles.cards_container}>
      <Heading title="𝐐𝐮𝐚𝐥𝐢𝐟𝐢𝐜𝐚𝐭𝐢𝐨𝐧𝐬" />
      <List
        style={{ marginTop: "2%", gap: "20%" }}
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <QualificationsCard item={item}>Card content</QualificationsCard>
          </List.Item>
        )}
      />
    </div>
  );
};
